import { useState } from "react";
import { Alerts, Btn, P } from "../../../../AbstractElements";

const HeartAlert = () => {
  const [active, setActive] = useState(true);
  return (
    <Alerts color="default" isOpen={active} className={`border-danger alert-dismissible fade p-0 mb-0`}>
      <div className="alert-arrow bg-danger">
        <i className="icon-heart" />
      </div>
      <P>
        {"Oh snap! Change a few things up "}
        <strong className="txt-dark">{" Notification check"}</strong>
      </P>
      <Btn className="p-0 border-0 me-2 ms-auto" onClick={() => setActive(false)}>
        <span className="bg-danger text-white px-3 py-1" aria-hidden="true">
          {"Alert"}
        </span>
      </Btn>
    </Alerts>
  );
};
export default HeartAlert;
